export default "https://housescan.app.solease.nl/static/media/water_pump.dc3f2044.svg";